import React from 'react'

const PassimPlayer = () => {
  return <div></div>
}

export default PassimPlayer
